/**
 * Receipt OCR — calls the Netlify Function proxy that holds the ai-gateway
 * virtual key server-side. The browser never sees an LLM API key.
 *
 * Related: task #65 Day 1 item (2). The old browser-direct Anthropic call
 * was deleted on 2026-05-17 because it bundled the API key into the CRA
 * artefact.
 */
import { auth } from '../firebase/config';

const USE_MOCK = process.env.REACT_APP_USE_MOCK === 'true';
const FUNCTION_URL = '/.netlify/functions/extract-receipt';

function mockExtract() {
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockResults = [
        { amount: 42.50, currency: 'SGD', category: 'F&B', vendor: 'Starbucks Orchard', date: '2026-04-05' },
        { amount: 156.80, currency: 'SGD', category: 'Transport', vendor: 'Grab', date: '2026-04-04' },
        { amount: 3500, currency: 'JPY', category: 'Supplies', vendor: 'Don Quijote', date: '2026-04-03' },
        { amount: 89.90, currency: 'SGD', category: 'Equipment', vendor: 'Decathlon', date: '2026-04-02' },
      ];
      resolve(mockResults[Math.floor(Math.random() * mockResults.length)]);
    }, 1500);
  });
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

async function proxyExtract(file) {
  const user = auth.currentUser;
  if (!user) throw new Error('Not signed in');
  const idToken = await user.getIdToken();

  const image_base64 = await fileToBase64(file);
  const media_type = file.type || 'image/jpeg';

  const response = await fetch(FUNCTION_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ image_base64, media_type }),
  });
  if (!response.ok) {
    const err = await response.text();
    console.error('extract-receipt function error:', err);
    throw new Error('Failed to extract receipt data');
  }

  const data = await response.json();
  const text = data.content[0].text.trim();
  try {
    return JSON.parse(text);
  } catch {
    const match = text.match(/\{[\s\S]*\}/);
    if (match) return JSON.parse(match[0]);
    throw new Error('Could not parse extraction result');
  }
}

export async function extractReceipt(file) {
  if (USE_MOCK) return mockExtract();
  return proxyExtract(file);
}
